
export const projectTitle = "OASI on the Street"
export const APIurl = /*!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'http://localhost:8808' :*/ 'https://api.mosaicorefugees.org'

export function hasChanges(obj1: any, obj2: any): boolean {
    // Stessa referenza o stesso valore primitivo
    if (obj1 === obj2) return false;

    // Uno è null/undefined e l'altro no
    if (obj1 == null || obj2 == null) return true;

    // Tipi diversi
    if (typeof obj1 !== typeof obj2) return true;

    // Date
    if (obj1 instanceof Date && obj2 instanceof Date) {
        return obj1.getTime() !== obj2.getTime();
    }

    // Array
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return true;
        for (let i = 0; i < obj1.length; i++) {
            if (hasChanges(obj1[i], obj2[i])) return true;
        }
        return false;
    }

    // Oggetti plain
    if (typeof obj1 === "object" && typeof obj2 === "object") {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return true;

        for (const key of keys1) {
            if (!keys2.includes(key)) return true;
            if (hasChanges(obj1[key], obj2[key])) return true;
        }
        return false;
    }

    // Primitivi (number, string, boolean, bigint, symbol, ecc.)
    return obj1 !== obj2;
}

export function convertNumbersToBooleans<T>(obj: T): T {
    if (obj === null || obj === undefined) return obj;

    if (Array.isArray(obj)) {
        return obj.map(item => convertNumbersToBooleans(item)) as any;
    }

    if (typeof obj === "object") {
        const result: any = {};
        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;
            const val = (obj as any)[key];

            if (val === 0) {
                result[key] = false;
            } else if (val === 1) {
                result[key] = true;
            } else if (typeof val === "object" && val !== null) {
                result[key] = convertNumbersToBooleans(val);
            } else {
                result[key] = val;
            }
        }
        return result;
    }

    // Valori primitivi non oggetti
    return obj;
}

// UTILS DOWNLOAD CSV

type CsvOptions<T> = {
    data: T[]
    fields?: string[]        // ora è string, così accetta "coordinates.lat"
    filename?: string
    filter?: (item: T) => boolean
    separator?: string
}

export function downloadCSV<T>({
                                   data,
                                   fields,
                                   filename = "export.csv",
                                   filter,
                                   separator = ",",
                               }: CsvOptions<T>) {
    const rows = filter ? data.filter(filter) : data
    if (!rows.length) return

    const firstRow = rows[0] as Record<string, unknown>
    const effectiveFields: string[] =
        fields && fields.length
            ? fields
            : Object.keys(firstRow)

    const header = effectiveFields

    const body = rows.map(row =>
        effectiveFields.map(path => {
            const value = getByPath(row, path)
            const str = value == null ? "" : String(value)
            const escaped = str.replace(/"/g, '""')
            return `"${escaped}"`
        })
    )

    const csvContent =
        [header, ...body]
            .map(cols => cols.join(separator))
            .join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

function getByPath(obj: unknown, path: string): unknown {
    return path.split(".").reduce((acc: any, key) => {
        if (acc == null) return undefined
        return acc[key]
    }, obj as any)
}

export const isMobileDevice = () => {
    if (typeof navigator === "undefined") return false // lato server
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}